import axios from 'axios';
import AxiosMockAdapter from 'axios-mock-adapter';


const axiosInstance = axios.create();

export default axiosInstance;
